export enum SalaryInsuranceFlowRouteEnum {
  DEFAULT = "default",
  CONFIRM = "confirm",
  RECEIPT = "receipt",
}
